import { render, staticRenderFns } from "./palette.vue?vue&type=template&id=322735e2&scoped=true&"
import script from "./palette.vue?vue&type=script&lang=js&"
export * from "./palette.vue?vue&type=script&lang=js&"
import style0 from "./palette.vue?vue&type=style&index=0&id=322735e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322735e2",
  null
  
)

export default component.exports